import { render, staticRenderFns } from "./SelectCard.vue?vue&type=template&id=33c2948a&scoped=true&"
import script from "./SelectCard.vue?vue&type=script&lang=js&"
export * from "./SelectCard.vue?vue&type=script&lang=js&"
import style0 from "./SelectCard.vue?vue&type=style&index=0&id=33c2948a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c2948a",
  null
  
)

export default component.exports